import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FormCheckbox, { FormCheckboxProps } from '../../partials/FormCheckbox';

interface Props extends Omit<FormCheckboxProps, 'id' | 'name' | 'label'> {}

const UnderstandsSueabilityCheckbox: FC<Props> = props => {
  const { t } = useTranslation();
  return (
    <FormCheckbox
      id="understandsSueability"
      name="understandsSueability"
      label={t('contactUs.dmca.sueabilityCheckbox')}
      {...props}
    />
  );
};

UnderstandsSueabilityCheckbox.displayName = 'UnderstandsSueabilityCheckbox';

export default UnderstandsSueabilityCheckbox;
